import { render } from "./Notice.m.vue?vue&type=template&id=7be94cca"
import script from "./Notice.m.vue?vue&type=script&lang=js"
export * from "./Notice.m.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__